import { Component, OnInit,Input} from '@angular/core';
import { Location } from '@angular/common';
import { FormGroup, Validators, FormBuilder, FormArray } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { LoadingState } from '../../loading/loading.component';
import { forkJoin } from 'rxjs';
import * as moment from 'moment';
import {PerExecutionService} from '../../../services/per-execution.service';
import { SettingService} from '../../../services/setting.service';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ConfirmDialogComponent } from '../../../../core/components/confirm-dialog/confirm-dialog.component';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-rawmaterial-qa-qc-lab-inner-tab',
  templateUrl: './rawmaterial-qa-qc-lab-inner-tab.component.html',
  styleUrls: ['./rawmaterial-qa-qc-lab-inner-tab.component.scss']
})
export class RawmaterialQaQcLabInnerTabComponent implements OnInit {
  @Input() projectId:number; 
  form: FormGroup;
  loading: LoadingState = LoadingState.NotReady;
  labDocumentList:any = [];
  labDetail:any = [];
  @Input() approveStatus:any = [];
  dialogRef: MatDialogRef<ConfirmDialogComponent>;

  constructor(
    private location: Location,
    private formBuilder: FormBuilder,
    private router: Router,
    private route: ActivatedRoute,
    private perExecutionService:PerExecutionService,
    private toastr: ToastrService,
    public dialog: MatDialog,
    public settingService:SettingService,
  ) { }

  ngOnInit() {
    this.form = this.formBuilder.group({
      project:[this.projectId],
      protection_type:[null,Validators.required],
      area_of_lab:[null,Validators.required],
      rental_cost:[null,Validators.required],
      capacity:[null,Validators.required],
      protection_cost:[null,Validators.required],
      requirment_s_date:[null,Validators.required],
      requirment_e_date:[null,Validators.required],
      budgeted_cost:[null,Validators.required],
      executed_cost:[null,Validators.required],
      documents:this.formBuilder.array([
        // this.createDocument()
      ])
    })

    if(this.projectId){
      this.getLabDetails();
    }
  }

  save(){
    if(this.form.valid){
      var lab_documents_data = [];
      lab_documents_data = this.form.value.documents;
      //console.log(godown_documents_data);

      this.loading = LoadingState.Processing

      const data = {
        project: this.projectId,
        protection_type: this.form.value.protection_type,
        area_of_lab:this.form.value.area_of_lab,
        rental_cost: this.form.value.rental_cost,
        capacity: this.form.value.capacity,
        protection_cost: this.form.value.protection_cost,
        requirment_s_date:this.settingService.getProperDate(this.form.value.requirment_s_date).toISOString(),//aa
        requirment_e_date:this.settingService.getProperDate(this.form.value.requirment_e_date).toISOString(),//aa
        budgeted_cost: this.form.value.budgeted_cost,
        executed_cost: this.form.value.executed_cost
      }
      this.labDocumentList = [];
      this.perExecutionService.addQcLabOffice(data).subscribe(
        res => {
          var forkArray = [];

          lab_documents_data.forEach(x => {
              const formData: any = new FormData();
              formData.append("project",this.projectId);
              formData.append("module_id", res.id);
              formData.append("document_name", x.document_name);
              formData.append("document", x.godown_document, x.godown_document['name']);
              forkArray.push(this.perExecutionService.addQcLabDocumentOffice(formData))
          })
          forkJoin(forkArray).subscribe(
            (result: any[]) => {
              // console.log(result)
              result.forEach(y => {
                this.labDocumentList.push(y)
              })
              
              // this.add_tender_document()
              this.loading = LoadingState.Ready;
            },
            err => {
              this.loading = LoadingState.Ready;
              // console.log(err)
            }
          )
          this.loading = LoadingState.Ready;
          this.toastr.success('Data has been saved','',{
            timeOut: 3000,
            });
        },
        error=>{
          //console.log(error);
          this.loading = LoadingState.Ready;
          this.toastr.error('Something went wrong', '', {
            timeOut: 3000,
            });
        }
      )
     // console.log(data);
    }else{
      this.markFormGroupTouched(this.form);
    }
  }

  getLabDetails(){
    this.perExecutionService.getQcLabOffice(this.projectId).subscribe(
      res=>{
        if(res['result'][0]){
          this.labDetail = res['result'][0];
         // console.log(this.labDetail);
          this.labDocumentList = res['result'][0].document_details;
          var start_date = new Date(this.labDetail['requirment_s_date'])
            this.labDetail.requirment_s_date = {
              year: start_date.getFullYear(),
              month: start_date.getMonth()+1,
              day: start_date.getDate()
        
            }
            var end_date = new Date(this.labDetail['requirment_e_date'])
            this.labDetail.requirment_e_date = {
              year: end_date.getFullYear(),
              month: end_date.getMonth()+1,
              day: end_date.getDate()
              
            }
          
          this.labDetail.budgeted_cost = parseFloat(this.labDetail.budgeted_cost).toFixed(2);
          this.labDetail.executed_cost = parseFloat(this.labDetail.executed_cost).toFixed(2);
          this.labDetail.protection_cost = parseFloat(this.labDetail.protection_cost).toFixed(2);
          this.labDetail.rental_cost = parseFloat(this.labDetail.rental_cost).toFixed(2);
        }
        this.loading = LoadingState.Ready;
      },
      error => {
       /// console.log(error);
        this.loading = LoadingState.Ready;
        this.toastr.error('Something went wrong', '', {
          timeOut: 3000,
          });
      }
    )
  }

  getFile(file: string) {
    var fileName = file.split('.')
    var fileExt = fileName[fileName.length - 1];
    if (fileExt == 'jpg' || fileExt == 'jpeg' || fileExt == 'png') {
      return file;
    }
    else {
      return 'assets/img/pdf.png'
    }
  }

  editDoc(index) {
    this.labDocumentList[index]['isEdit'] = true
    this.labDocumentList[index]['isFieldError'] = false
  }

  renameDoc(index) {
    if (this.labDocumentList[index]['document_name'] == '') {
      this.labDocumentList[index]['isFieldError'] = true;
    }
    else {
      this.loading = LoadingState.Processing
      this.labDocumentList[index]['isFieldError'] = false;
      var data = {
        document_name: this.labDocumentList[index]['document_name']
      }

      
      this.perExecutionService.editQcLabDocumentOffice(this.labDocumentList[index]['id'], data).subscribe(
        res => {
          // console.log(res)
          this.labDocumentList[index]['isEdit'] = false
          this.loading = LoadingState.Ready
        },
        error => {
          // console.log(error)
          this.loading = LoadingState.Ready
        }
      )
    }
  }

  deleteDoc(index) {

    this.dialogRef = this.dialog.open(ConfirmDialogComponent, {
      disableClose: false
    });

    this.dialogRef.componentInstance.confirmMessage = "Are you sure you want to delete?"

    this.dialogRef.afterClosed().subscribe(result => {
     if(result){
      this.loading = LoadingState.Processing
      this.perExecutionService.delteQcLabDocumentOffice(this.labDocumentList[index]['id']).subscribe(
      res => {
        this.labDocumentList.splice(index, 1)
        // console.log(res)
        this.loading = LoadingState.Ready
      },
      error => {
        // console.log(error)
        this.loading = LoadingState.Ready
      }
    )
	 }
	 this.dialogRef = null;
	 })
    
  }

  update(){
    if(this.form.valid){
     // console.log(this.labDetail);
      var lab_documents_data = [];
      lab_documents_data = this.form.value.documents;

      if(this.form.value.documents.length > 0){
        var forkArray = [];
        lab_documents_data.forEach(x => {
            const formData: any = new FormData();
            formData.append("project", this.projectId);
            formData.append("module_id", this.labDetail.id);
            formData.append("document_name", x.document_name);
            formData.append("document", x.godown_document, x.godown_document['name']);
            forkArray.push(this.perExecutionService.addQcLabDocumentOffice(formData))
        })
        forkJoin(forkArray).subscribe(
          result => {
            // console.log(result)
            result.forEach(y => {
              this.labDocumentList.push(y)
            })
           
            // this.add_tender_document();
            this.loading = LoadingState.Ready;
          },
          err => {
            this.loading = LoadingState.Ready;
            // console.log(err)
          }
        )
        this.updateLab();
      }

      else{
        this.updateLab();
      }
    }
    else{
      this.markFormGroupTouched(this.form);
    }
  }

  updateLab(){
    if(this.form.valid){
      this.loading = LoadingState.Processing

      const updateData = {
        project: this.projectId,
        protection_type: this.form.value.protection_type,
        area_of_lab:this.form.value.area_of_lab,
        rental_cost: this.form.value.rental_cost,
        capacity: this.form.value.capacity,
        protection_cost: this.form.value.protection_cost,
        requirment_s_date:this.settingService.getProperDate(this.form.value.requirment_s_date).toISOString(),//aa
        requirment_e_date:this.settingService.getProperDate(this.form.value.requirment_e_date).toISOString(),//aa
        budgeted_cost: this.form.value.budgeted_cost,
        executed_cost: this.form.value.executed_cost
      }

      this.perExecutionService.editQcLabOffice(this.labDetail.id,updateData).subscribe(
        res =>{
        //  console.log(res)
          this.loading = LoadingState.Ready;
          this.toastr.success('Data has been saved','',{
            timeOut: 3000,
            });
        },
        error =>{
         this.loading = LoadingState.Ready;
         this.toastr.error('Something went wrong', '', {
          timeOut: 3000,
          });
        }
      )

    }
  }

  createDocument(){
    return this.formBuilder.group({
      document_name: [null, Validators.required],
      document: [null, Validators.required],
      godown_document: null
    })
  }

  getFormArrayControl(form) {
    return form.get('documents').controls
  }

  addDocument()
  {
    const control = <FormArray>this.form.controls['documents'];
    control.push(this.createDocument());
  }

  deleteDocument(index:number)
  {
    const control = <FormArray>this.form.controls['documents'];
    control.removeAt(index);
  }
  onSelectFile(event, index){
    //console.log(event.target.files);
    if (event.target.files && event.target.files[0]) {
      var filesAmount = event.target.files.length;
      for (let i = 0; i < filesAmount; i++) {
        var reader = new FileReader();
        reader.onload = (event) => {
          // console.log(event.target['result']);
        }
        const control = <FormArray>this.form.controls['documents'];
        control.at(index).patchValue({
          document: event.target.files[0]['name'],
          godown_document: event.target.files[0]
        })
        reader.readAsDataURL(event.target.files[i]);
      }
    }
  }
  markFormGroupTouched(formGroup: FormGroup) {
    (<any>Object).values(formGroup.controls).forEach(control => {
      control.markAsTouched();
      if (control.controls) {
        control.controls.forEach(c => this.markFormGroupTouched(c));
      }
    });
  }

  isFieldValid(form: FormGroup, field: string) {
    return !form.get(field).valid && (form.get(field).dirty || form.get(field).touched);
  }

  displayFieldCss(form: FormGroup, field: string) {
    return {
      'is-invalid': form.get(field).invalid && (form.get(field).dirty || form.get(field).touched),
      'is-valid': form.get(field).valid && (form.get(field).dirty || form.get(field).touched)
    };
  }

}
